import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //主页
    {
      path: '/',
      name: 'index',
      component: () => import("./views/newIndex.vue"),
      meta: {
        title: '设备管理',
      }
    },
    //单卡设备
    {
      path: '/singleIndex',
      name: 'singleIndex',
      component: () => import("./views/singleIndex.vue"),
      meta: {
        title: '设备管理',
        login: false
      }
    },    
    //新讯设备
    {
      path: '/xinXunIndex',
      name: 'xinXunIndex',
      component: () => import("./views/xinXun/xinXunIndex.vue"),
      meta: {
        title: '设备管理',
        login: false
      }
    },
    //云兔卡
    {
      path: '/yunTuIndex',
      name: 'yunTuIndex',
      component: () => import("./views/yunTuIndex.vue"),
      meta: {
        title: '设备管理',
        login: false
      }
    },
    //绑定
    {
      path: '/binding',
      name: 'binding',
      component: () => import("./views/binding.vue"),
      
    },
    //跳转充值的提示页
    {
      path: '/warn',
      name: 'warn',
      component: () => import("./views/rules/warn.vue"),
     
    },
    //切换网络说明
    {
      path: '/warnNetwork',
      name: 'warnNetwork',
      component: () => import("./views/rules/warnNetwork.vue"),
     
    },
    //详情页
    {
      path: '/weixin/card/usage',
      name: 'usage',
      component: () => import("./views/usage.vue"),
      meta: {
        title: '卡信息',
      }
    }, 
    //套餐充值
    {
      path: '/plan_list',
      name: 'plan_list',
      component: () => import("./views/plan_list.vue"),
      meta: {
        title: '套餐充值',
      }
    },
    // 套餐详情
    {
      path: '/package_details',
      name: 'package_details',
      component: () => import("./views/packageDetails.vue"),
      meta: {
        title: '套餐详情',
      }
    },
    //卡券兑换
    {
      path: '/coupon',
      name: 'coupon',
      component: () => import("./views/coupon.vue"),
      meta: {
        title: '卡券兑换',
      }
    },
    //问题中心
    {
      path: '/question',
      name: 'question',
      component: () => import("./views/questionIndex.vue"),
      meta: {
        title: '问题中心',
      }
    },
    {
      path:'/find_plan',
      name:'find_plan',
      component:()=>import("./views/find_plan.vue")
    },
    {
      path:'/revoke_plan',
      name:'revoke_plan',
      component:()=>import("./views/revoke_plan.vue")
    },
    //退款协议
    {
      path:'/argument',
      name:'argument',
      component:()=>import("./views/argument.vue"),
      meta: {
        title: '退款协议',
      }
    },
    //退款列表
    {
      path:'/refundList',
      name:'refundList',
      component:()=>import("./views/refundList.vue"),
      meta: {
        title: '退款列表',
      }
    },
    //退款申请
    {
      path:'/applying',
      name:'applying',
      component:()=>import("./views/applying.vue"),
      meta: {
        title: '退款申请',
      }
    },
    //绑定帐号
    {
      path:'/bindAccount',
      name:'bindAccount',
      component:()=>import("./views/bindAccount.vue"),
      meta: {
        title: '登录',
        login: false
      }
    },
    {
      path:'/realNameCourse',
      name:'realNameCourse',
      component:()=>import("./views/realNameCourse.vue"),
      meta: {
        title: '实名教程',
      }
    },
    {
      path:'/to_realName',
      name:'to_realName',
      component:()=>import("./views/to_realName.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path:'/to_realName_iframe',
      name:'to_realName_iframe',
      component:()=>import("./views/to_realName_iframe.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path: '/realName',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children: [
        {
          path:'index',
          name: 'realName',
          component: ()=>import("./views/realName/index.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'operatorName',
          name: 'operatorName',
          component: ()=>import("./views/realName/operatorName.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'realNameUnicom',
          name: 'realNameUnicom',
          component: ()=>import("./views/realName/realNameUnicom.vue"),
          meta: {
            login: false
          }
        },
      ]
    },
    {
      path: '/more_flow',
      name: 'MoreFlowPlan',
      component:()=>import("./views/more_flow_plan.vue"),
      meta: {
        title: '加油包叠加对应套餐'
      }
    },
    {
      path: '/card_invoice',
      name: 'card_invoice',
      component:()=>import("./views/card_invoice.vue"),
      meta: {
        title: '开具发票'
      }
    },
    {
      path: '/recharge',
      name: 'recharge',
      component:()=>import("./views/recharge.vue"),
      meta: {
        title: '充值'
      }
    },
    //个人中心
    {
      path: '/userCenter',
      component: ()=>import("./views/userCenter/userCenterWrap.vue"),
      children:[
          {
              path:'index',
              component: ()=>import("./views/userCenter/index.vue"),
              meta: {
                  title: '个人中心',
              }
          },
          {
              path:'rechargeRecord',
              component: ()=>import("./views/userCenter/rechargeRecord.vue"),
              meta: {
                  title: '充值记录',
              }
          },
          {
              path:'userCenterAddress',
              component: ()=>import("./views/userCenter/userCenterAddress.vue"),
              meta: {
                  title: '收获地址',
              }
          },
          {
              path:'contactUs',
              component: ()=>import("./views/userCenter/contactUs.vue"),
              meta: {
                  title: '联系我们',
              }
          },
          {
            path:'userCenterNews',
            component: ()=>import("./views/userCenter/userCenterNews.vue"),
            meta: {
                title: '我的消息',
            }
          },
          {
            path:'userCenterCoupon',
            component: ()=>import("./views/userCenter/userCenterCoupon.vue"),
            meta: {
                title: '我的优惠券',
            }
          },
          {
              path:'helpCenter',
              component: ()=>import("./views/userCenter/helpCenter.vue"),
              meta: {
                  title: '帮助中心',
              }
          },
          {
              path:'salesRecords',
              component: ()=>import("./views/userCenter/salesRecords.vue"),
              meta: {
                  title: '售后记录',
              }
          },
          {
              path:'addSalesRecords',
              component: ()=>import("./views/userCenter/addSalesRecords.vue"),
              meta: {
                  title: '售后申请',
              }
          },
          {
              path:'realName',
              component: ()=>import("./views/userCenter/realName.vue"),
              meta: {
                  title: '认证教程',
              }
          },
        //   {
        //     path:'refundOrder',
        //     component: ()=>import("./views/userCenter/refundOrder.vue"),
        //     meta: {
        //         title: '订单退款',
        //     }
        // },
      ]
    },
    //充值引导流程
    {
      path: '/process',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path: 'index',
          name: 'processIndex',
          component: ()=>import("./views/process/processIndex.vue"),
        },
        {
          path: 'plan',
          name: 'processPlan',
          component: ()=>import("./views/process/processPlan.vue"),
        },
      ]
    },
    //中间页
    {
      path: '/mifi',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path:'index',
          name: 'process',
          component: ()=>import("./views/middlePages/process.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'authority',
          name: 'authority',
          component: ()=>import("./views/middlePages/authority.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'authority_noPhoneLogin',
          name: 'authority_noPhoneLogin',
          component: ()=>import("./views/middlePages/authority_noPhoneLogin.vue"),
          meta: {
            login: false
          }
        },
      ]
    },
    //活动
    {
      path: '/activity',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        // {
        //   path:'repeatRecharge',
        //   name: 'repeatRecharge',
        //   component: ()=>import("./views/activity/repeatRecharge.vue"),
        // },
        {
          path: 'dragonBoatFestival',
          name: 'dragonBoatFestival',
          component: ()=>import("./views/activity/dragonBoatFestival.vue")
        },{
          path: 'nationalDayActivities',
          name: 'nationalDayActivities',
          component: ()=>import("./views/activity/nationalDayActivities.vue")
        },{
          path: 'balanceRecharge',
          name: 'balanceRecharge',
          component: ()=>import("./views/activity/balanceRecharge.vue")
        },{
          path: 'doubleTwelveActivities',
          name: 'doubleTwelveActivities',
          component: ()=>import("./views/activity/doubleTwelveActivities.vue"),
        }
      ]
    },
    // 问题中心
    {
      path: '/question',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path:'guardian',
          name: 'guardian',
          component: ()=>import("./views/question/guardian.vue"),
        }
      ]
    },
    // 金币签到个人中心
    {
      path: '/newUserCenter', 
      name: 'emptyLayout',
      component: ()=>import('./components/common/emptyLayout.vue'),
      children: [
        {
          path: 'index',
          component: ()=>import('./views/newUserCenter/index.vue'),
          meta: {
            title: '个人中心'
          }
        },{
          path: 'myGold',
          component: ()=>import('./views/newUserCenter/myGold.vue'),
          meta: {
            title: '我的金币',
            KATarget: true
          }
        },{
          name: 'signInEveryDay',
          path: 'signInEveryDay',
          component: ()=>import('./views/newUserCenter/signInEveryDay.vue'),
          meta: {
            title: '天天签到领金币',
            keepAlive: true,
          }
        },{
          path: 'customerService',
          component: ()=>import('./views/newUserCenter/customerService.vue'),
          meta: {
            title: '客户服务'
          }
        },{
          path: 'mySetUp',
          component: ()=>import('./views/newUserCenter/mySetUp.vue'),
          meta: {
            title: '我的设置'
          }
        },{
          path: 'goldExchange',
          name: "goldExchange",
          component: ()=>import('./views/newUserCenter/goldExchange.vue'),
          meta: {
            title: '金币兑换',
            keepAlive: true,
          }
        },{
          path: 'goodsDetails/:id',
          component: ()=>import('./views/newUserCenter/goodsDetails.vue'),
          meta: {
            title: '商品详情',
            KATarget: true
          }
        }, {
          path: 'orderFillIn/:id',
          component: ()=>import('./views/newUserCenter/orderFillIn.vue'),
          meta: {
            title: '订单填写'
          }
        },{
          path: 'goldLoot',
          component: ()=>import('./views/newUserCenter/goldLoot.vue'),
          meta: {
            title: '金币夺宝'
          }
        },{
          name: 'myPrize',
          path: 'myPrize',
          component: ()=>import('./views/newUserCenter/myPrize.vue'),
          meta: {
            title: '我的奖品',
            keepAlive: true,
          }
        },{
          path: 'userMaterial',
          component: ()=>import('./views/newUserCenter/userMaterial.vue'),
          meta: {
            title: '个人资料'
          }
        },{
          path: 'recordQuery',
          component: ()=>import('./views/newUserCenter/recordQuery.vue'),
          meta: {
            title: '记录查询'
          }
        },{
          path: 'aboutUs',
          component: ()=>import('./views/newUserCenter/aboutUs.vue'),
          meta: {
            title: '关于我们'
          }
        }, {
          path: 'flowCouponUse/:id/:code',
          component: ()=>import('./views/newUserCenter/flowCouponUse.vue'),
          meta: {
            title: '奖品详情'
          }
        }, {
          path: 'prize_record_detail',
          component: ()=>import('./views/newUserCenter/prize_record_detail.vue'),
          meta: {
            title: '奖品详情'
          }
        }, {
          path: 'addressList',
          component: ()=>import('./views/newUserCenter/addressList.vue'),
          meta: {
            title: '收获地址'
          }
        }, {
          path: 'addAndEditAddress',
          component: ()=>import('./views/newUserCenter/addAndEditAddress.vue'),
          meta: {
            title: '添加地址'
          }
        }, {
          path: 'search',
          component: ()=>import('./views/newUserCenter/search.vue'),
          meta: {
            title: '搜索'
          }
        },{
          path:'userCenterCoupon',
          component: ()=>import("./views/newUserCenter/userCenterCoupon.vue"),
          meta: {
              title: '我的优惠券',
          }
        },{
          path:'complaintCenter',
          component: ()=>import("./views/newUserCenter/complaintCenter.vue"),
          meta: {
              title: '投诉中心',
          }
        },{
          path:'complaintSubmit',
          component: ()=>import("./views/newUserCenter/complaintSubmit.vue"),
          meta: {
              title: '提交投诉',
          }
        },{
          path:'complaintRecord',
          component: ()=>import("./views/newUserCenter/complaintRecord.vue"),
          meta: {
              title: '投诉记录',
          }
        },{
          path:'complaintDetail',
          component: ()=>import("./views/newUserCenter/complaintDetail.vue"),
          meta: {
              title: '投诉详情',
          }
        },{
          path:'QR_code',
          component: ()=>import("./views/newUserCenter/QR_code.vue"),
          meta: {
              title: '客服二维码',
          }
        },{
          path:'openRecord',
          component: ()=>import("./views/newUserCenter/openRecord.vue"),
          meta: {
              title: '开通会员记录',
              KATarget: true
          }
        },{
          path:'openMember',
          component: ()=>import("./views/newUserCenter/openMember.vue"),
          meta: {
              title: '开通会员',
              KATarget: true
          }
        },{
          path:'vipRecharge',
          component: ()=>import("./views/newUserCenter/vipRecharge.vue"),
          meta: {
              title: '支付会员费',
          }
        },{
          path:'goldTransfer',
          component: ()=>import("./views/newUserCenter/goldTransfer.vue"),
          meta: {
              title: '金币转赠',
              KATarget: true
          }
        },{
          path:'taskPackageRecord',
          component: ()=>import("./views/newUserCenter/taskPackageRecord.vue"),
          meta: {
              title: '任务包记录',
              KATarget: true
          }
        },{
          path:'memberOrderDetail',
          component: ()=>import("./views/newUserCenter/memberOrderDetail.vue"),
          meta: {
              title: '会员卡详情',
          }
        },{
          path:'userCenterNews',
          component: ()=>import("./views/newUserCenter/userCenterNews.vue"),
          meta: {
              title: '服务通知',
          }
        },{
          path:'myPrezzie',
          component: ()=>import("./views/newUserCenter/myPrezzie.vue"),
          meta: {
              title: '我的礼品',
              KATarget: true
          }
        },{
          path:'phonePrezzie',
          component: ()=>import("./views/newUserCenter/phonePrezzie.vue"),
          meta: {
              title: '话费礼包',
              KATarget: true
          }
        },{
          path:'memberCoupon',
          component: ()=>import("./views/newUserCenter/memberCoupon.vue"),
          meta: {
              title: '大额优惠券',
              KATarget: true
          }
        },{
          path:'warrantyReplacement',
          component: ()=>import("./views/newUserCenter/warrantyReplacement.vue"),
          meta: {
              title: '保修换新',
              KATarget: true
          }
        },{
          path:'sendingGold',
          component: ()=>import("./views/newUserCenter/sendingGold.vue"),
          meta: {
              title: '充值返金币',
              KATarget: true
          }
        },{
          path:'goldCoinCashOffset',
          component: ()=>import("./views/newUserCenter/goldCoinCashOffset.vue"),
          meta: {
              title: '金币抵现',
              KATarget: true
          }
        },{
          path:'goldDouble',
          component: ()=>import("./views/newUserCenter/goldDouble.vue"),
          meta: {
              title: '每日签到奖励翻倍',
              KATarget: true
          }
        },{
          path:'selectPrezzie',
          component: ()=>import("./views/newUserCenter/selectPrezzie.vue"),
          meta: {
              title: '新讯大礼包',
              KATarget: true
          }
        }
      ]
    },
    // 活码需求 微信登录流程不需要手机号
    {
      path: '/notPhoneLogin',
      component: () => import('./components/common/emptyLayout.vue'),
      children: [
        {
          path: 'index',
          name: 'notPhoneLoginIndex',
          component: () => import('./views/notPhoneLogin/index.vue'),
          meta: {
            title: '首页',
          }
        },
        {
          path: 'login',
          component: () => import('./views/notPhoneLogin/login.vue'),
          meta: {
            title: '登录',
          }
        },
      ]
    },
    {
      path: '*',
      // component:()=>import("./views/walkmanWifi.vue"),
    },
  ]
})
